import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmStop } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm.js';
import style from './page-stop.module.scss.js';

const PageStop = () => {
  const label = useLabel();
  useLlm(state => state.components);
  const threadId = useLlm(state => state.threadId);
  const {
    abort
  } = useLlm(state => state.actions);
  return jsx("button", {
    type: "button",
    className: getClassNames(style.stop),
    disabled: !threadId,
    "aria-disabled": !threadId,
    "aria-label": label('llm.stopResponse'),
    onClick: abort,
    children: jsx(IconLlmStop, {})
  });
};

export { PageStop };
//# sourceMappingURL=page-stop.js.map
